import { useState, useEffect } from 'react';
import { getJobsAPI } from '../services/jobsAPI';
import { useLoading } from '../contexts/LoadingContext';
import { useError } from '../contexts/ErrorContext';
import { resolveTimezone } from '@components/ui/timezone/timezoneMappings';

/**
 * Gets dropdown options for jobs
 * 
 * @returns {DropdownOption[]} jobNameOptions
 * @returns {Function} setJobNameOptions - setter function, usually used to add a new option when a job is created
 * 
 * @category Hooks - Dropdown Options
 */
const useJobOptions = () => {
    const [jobNameOptions, setJobNameOptions] = useState([]);
    const { showLoading, hideLoading } = useLoading();
    const { showError } = useError();

    useEffect(() => {
        const fetchJobs = async () => {
            showLoading('Getting Jobs...');
            try {
                const response = await getJobsAPI();
                
                if (!response.success) {
                    throw new Error(`HTTP error: ${response.message}`);
                }
                const jobs = response.data;
                
                if(jobs.length > 0){
                    const jobOptions = jobs.map(job => ({
                        value: job.JobID,
                        label: `Job_${job.Job_Number}_${job.Job_Name}`,
                        timezone: resolveTimezone(job.Timezone)
                    }));
                    setJobNameOptions(jobOptions);
                }                
            } catch (error) {
                console.log(error)
                showError(`Error Getting Jobs - ${error.message}`)
            } finally {
                hideLoading();
            }
        };

        fetchJobs();
    }, []); // eslint-disable-line

    return { jobNameOptions, setJobNameOptions };
};

export default useJobOptions;
